import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import { SENTRY_DSN, SEGMENT_ENV } from 'config';
import type { LoginContext } from 'features/auth';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: APP_VERSION || 'unknown',
    environment: SEGMENT_ENV,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/delogue\.com/, /localhost/],
    integrations: [
      Sentry.replayIntegration({
        networkDetailAllowUrls: ['.*'],
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
        networkRequestHeaders: ['cf-ray', 'content-type', 'server-timing'],
      }),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
  });
}

export const setSentryUser = (u: LoginContext) => {
  if (!u) return;

  Sentry.setUser({
    id: `${SEGMENT_ENV}:${u.id}`,
    email: u.email,
    username: u.name,
  });
  Sentry.setTags({
    organizationId: `${SEGMENT_ENV}:${u.organizationId.toString()}`,
    organizationName: u.organizationName,
    organizationType: u.organizationType === 1 ? 'Designer' : 'Supplier',
    userRoles: u.roleNames.join(','),
    userPlan: u.planType,
    userPlanTier: u.planTier,
    userSignupDate: u.signUpDate
      ? (() => {
          const parsed = parseInt(u.signUpDate, 10);
          if (!isNaN(parsed) && parsed > 0) {
            return new Date(parsed).toISOString().replace(/\.\d{3}Z$/, '.000Z');
          }
          return '';
        })()
      : '', // Necessary to match C# toString("o")
  });
};
